import { Circle, ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import placeholder from '../../assets/images/academics/faculty/female.png';
import co_ordinator from '../../assets/images/about/co_ordinator.jpg';

const data = {
  title: "Prof. Dr. Sucheta Golhar BPTh, MPTh, PhD",
  description:
    "Dear Students, splitIt is my pleasure to welcome you to Progressive Education Society’s Modern College of Physiotherapy, Pune-5. Over the last decades our Progressive Education Society, Pune-5 has leaped forward and we are among the leading institution in Maharashtra and indeed in India. Our Society had started the Bachelor of Physiotherapy (B.P.Th) course in the Academic year 2007-08 affiliated to Maharashtra University of Health Sciences, Nashik and approved by Government of Maharashtra. We believe in providing a dynamic learning environment to our students while maintaining high standards in teaching, faculty and infrastructure that are conducive to advanced learning.splitNow we are stepped forward with Master of Physiotherapy (M.P.Th) course under Maharashtra University of Health Sciences, Nashik with various specialties on PT in Cardio vascular respiratory Sciences and PT in Musculoskeletal Sciences and shortly with PT in Neurological Sciences and PT in community health Sciences. In the last five years we have come a long way but yet have miles to go and it will be possible because of those who have been with us in the past many years, those who are a energetic part of it today and those who will enthusiastically join us in coming years and will make our college excel radiantly in the years to come. Good luck and best wishes for a brilliant future. ",
  headings: ["About Principal", "Principal Profile"],
  career: [
    "Associate Professor in Management Sciences art P E S' Modern College of Engineering, Pune 05",
    "Assistant Professor in Management Sciences at P E S' Modern College of Engineering, Pune 05",
    "Deputy Secretary, Business Council, Progressive Education Society, Pune 05",
    "Member, Board of Life Members, Progressive Education Society, Pune 05",
    "Coordinator, PES' Modern Institute of Business Management, Modern College of Physiotherapy, Pune 05",
  ],
};

const Co_ordinator = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Grid
          m={10}
          sx={{
            margin: "auto",
            backgroundColor: "primary.light",
            p: { xs: 1, md: 3 },
          }}
          container
          position={"relative"}
        >
          <Grid item xs={12} py="2rem" textAlign="center">
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                display: "inline",
                textDecoration: "underline",
                textUnderlineOffset: "6px",
                fontWeight: "600",
              }}
            >
              Our Co-ordinator
            </Typography>
          </Grid>

          <Grid
            container
            justifyContent={"center"}
            alignItems={"start"}
            xs={12}
            md={4}
            sx={{ mb: { xs: 5, md: 0 } }}
          >
            <Card
              sx={{
                width: { xs: "80%", md: "80%" },
                position: "sticky",
                top: "170px",
                transform: { md: "translateY(-6rem)" },
              }}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  p: "1.5rem",
                }}
              >
                <img
                  src={co_ordinator}
                  alt="co-ordinator"
                  style={{
                    width: "100%",
                    height: "100%",
                    top: "30%",
                  }}
                />
                <Typography
                  variant="body2"
                  textAlign="center"
                  color={"primary.main"}
                  sx={{ px: { xs: "2rem", md: "0rem" }, pt: "10px" }}
                >
                  <span style={{ fontSize: "16px" }}>DR. NIVEDITA EKBOTE</span>
                  <br />
                  <span>
                    Ph.D (Management), Faculty Development Programme (FDP), MBA
                    (Dual Spl) Marketing, MBA (Finance), B.E. (E&TC).
                  </span>
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={8}>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{ px: { xs: "2rem", md: "0rem" }, color: "primary.main" }}
              fontSize={"1rem"}
            >
              Dear Students
            </Typography>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{
                px: { xs: "2rem", md: "0rem" },
                textIndent: "2rem",
                color: "primary.main",
              }}
              fontSize={"1rem"}
            >
              At Modern College of Physiotherapy training is taken as a
              continuous endeavour. Modern College of Physiotherapy was started
              in 2007. The motto of our institute is "ever to excel". Students
              are helped to define their goals and try to fulfil their ambitions
              by providing them with best available employment resources. It
              continues to shine with its speciality on the horizon of allied
              health sciences. I wish lots of success to the upcoming
              physiotherapists who will work for the welfare of the Healthcare
              System. We believe that education has to harness the innate
              potential of every individual.
            </Typography>
            <Typography
              variant="body2"
              textAlign="justify"
              mb={2}
              sx={{
                px: { xs: "2rem", md: "0rem" },
                textIndent: "2rem",
                color: "primary.main",
              }}
              fontSize={"1rem"}
            >
              Modern College of Physiotherapy nurtures its students to develop a
              holistic approach, a curious mindset and the ability to think
              innovatively to harness the opportunities emerging from challenges
              in the healthcare system. To achieve an all-round excellence, we
              strive to create a learning culture with emphasis on creative and
              analytical mind frame. At Modern College of Physiotherapy we take
              every possible effort to deliver the curriculum in the most
              effective manner helping the students acquire the required
              knowledge and skills. At the same time, we focus on the all-round
              personal and professional development of the students through
              brilliant faculty with great dedication, imbibing culture and
              values and professional ethics in the students, which helps them
              take decisions and create path that are good not only for them,
              but also for the society. It will be our privilege and pleasure to
              welcome you to this campus and look forward to building a mutually
              beneficial relationship.
            </Typography>

            <Accordion sx={{ mb: "2rem" }} defaultExpanded>
              <AccordionSummary id="panel1-header" expandIcon={<ExpandMore />}>
                <Typography
                  variant="body2"
                  color={"primary.main"}
                  sx={{
                    textDecoration: "underline",
                    textUnderlineOffset: "6px",
                    fontWeight: "600",
                    "&:hover": { textDecoration: "underline" },
                    fontSize: 16,
                  }}
                >
                  Career Profile:
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container columns={{ xs: 1, md: 2 }} spacing={2}>
                  <Grid item xs={12}>
                    {data.career.map((message, i) => (
                      <Stack
                        direction="row"
                        alignItems={"flex-start"}
                        justifyContent={"flex-start"}
                        mb={1}
                        sx={{ px: { xs: "2rem", md: "1rem" } }}
                        spacing={1}
                      >
                        <Circle
                          fontSize="small"
                          sx={{ color: "black", scale: "80%", pt: 0.5 }}
                        />

                        <Typography
                          variant="body2"
                          textAlign="justify"
                          fontSize={"1rem"}
                          color="primary.main"
                        >
                          {message}
                        </Typography>
                      </Stack>
                    ))}
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};

export default Co_ordinator;
